import {
    AccountModel,
    EEditorType,
    EPopupPosition,
    ListModel,
    TBrand,
    UserModel
} from "@cakemail-org/ui-components-v2"

export type TBeeEditor = {
    hidden?: boolean,
    className?: string,
    titleContent?: any,
    editorType: EEditorType,
    initContent: any,
    contentContext?: TBeeEditorContentContext,
    containerName?: string,

    onBrandingToggle?: () => Promise<any>,

    onSave?: (jsonFile: string, htmlFile: string) => Promise<void>,
    onChange?: (jsonFile: string, response: any) => void,
    onSaveAsTemplate?: (jsonFile: string) => void,
    onAutoSave?: (jsonFile: string) => void,
    onSend?: (htmlFile: string) => void,
    onLoad?: (jsonFile: string) => void,
    onError?: (errorMessage: string) => void,
    onWarning?: (alertMessage: string) => void,
} & (
        //if hidden is provided, onClose is required otherwise it will throw a type error
        | { hidden: true | false; onClose: () => void }
        | { hidden?: undefined; onClose?: undefined }
    )

export type TBeeEditorContentContext = {
    isSmart?: boolean,
    list?: ListModel,
    formAction?: string,
    popupPosition?: EPopupPosition,
}

export type TGetInitialBeeConfiguration = {
    reload?: boolean,
    getContentContext: () => TBeeEditorContentContext,
    account: AccountModel
    user: UserModel
    partnerBrand: TBrand
    userBrand?: TBrand
    editorType: EEditorType,
    containerName: string,
    getLocalContent: () => any,
    onSave?: (jsonFile: string, htmlFile: string) => void,
    onChange?: (jsonFile: string, response: any) => void,
    onSaveAsTemplate?: (jsonFile: string) => void,
    onAutoSave?: (jsonFile: string) => void,
    onSend?: (htmlFile: string) => void,
    onLoad?: (jsonFile: string) => void,
    onError?: (errorMessage: string) => void,
    onWarning?: (alertMessage: string) => void,
}

export enum EEditorCacheKeys {
    listAttributes = "editorListAttributesCache",
    listInterests = "editorListInterestsCache",
    tags = "editorTagsCache",
}